import { QuestionMarkCircleIcon } from "@heroicons/react/outline";
import { cva, type VariantProps } from "class-variance-authority";

import { HeaderProps } from "@/components/Stepper/Step/types";
import { BasicTooltip } from "@/components/ui/Tooltip";

const headerStyles = {
  container: cva("flex flex-col", {
    variants: {
      size: {
        desktop: "gap-3",
        dialog: "gap-0",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  stepInfo: cva("font-semibold text-blue-500", {
    variants: {
      size: {
        desktop: "text-md sm:text-sm",
        dialog: "text-xs",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  title: cva("font-bold text-gray-900 flex items-center gap-1", {
    variants: {
      size: {
        desktop: "text-3xl",
        dialog: "text-lg",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  description: cva("text-gray-600", {
    variants: {
      size: {
        desktop: "text-lg",
        dialog: "text-sm",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
};

export type HeaderStyleProps = VariantProps<typeof headerStyles.container>;

export const Header = ({
  stepNumber,
  totalSteps,
  title,
  titleTooltip,
  description,
  size = "desktop",
  layout = "default",
}: HeaderProps) => (
  <div className={headerStyles.container({ size })}>
    {totalSteps === 1 || layout === "sidebar" ? null : (
      <div className={headerStyles.stepInfo({ size })}>
        Step {stepNumber} of {totalSteps}
      </div>
    )}
    <div className={headerStyles.title({ size })}>
      {title}
      {titleTooltip && (
        <BasicTooltip content={titleTooltip}>
          <QuestionMarkCircleIcon className="ml-2 h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700" />
        </BasicTooltip>
      )}
    </div>
    <div className={headerStyles.description({ size })}>{description}</div>
  </div>
);
